/**
 * GridOverlay — Responsive grid overlay (12/8/4 columns) + optional 8px raster.
 * Reads --layout-columns-desktop/tablet/mobile from generated CSS tokens.
 * Ported from Builder-5 GridOverlay.jsx.
 */

interface GridOverlayProps {
  columns?: number;
  show8px?: boolean;
  viewport?: 'desktop' | 'tablet' | 'mobile';
}

const VIEWPORT_COLUMNS = {
  desktop: 12,
  tablet: 8,
  mobile: 4,
} as const;

export function GridOverlay({ columns, show8px = false, viewport = 'desktop' }: GridOverlayProps) {
  const columnCount = columns ?? VIEWPORT_COLUMNS[viewport];

  return (
    <div
      className="grid-overlay"
      aria-hidden="true"
      style={{ '--grid-overlay-columns': columnCount } as React.CSSProperties}
    >
      <div className="grid-columns">
        {Array.from({ length: columnCount }).map((_, i) => (
          <div key={i} className="grid-column" />
        ))}
      </div>
      {show8px && <div className="grid-8px" />}
    </div>
  );
}
